// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type {
  SourceAsset,
  TransferOperationData,
  FundSearchResult,
} from '@shared/portfolio-operations/types';

interface TransferOperationFormSetupProps {
  sourceAsset: SourceAsset;
  portfolioFunds?: FundSearchResult[];
  onFormDataChange?: (data: TransferOperationData) => void;
  onFormValidationChange?: (isValid: boolean) => void;
}

export const useTransferOperationForm = (props: TransferOperationFormSetupProps) =>
  props;
